import dayjs from 'dayjs';
import { UserEvent } from './user-event.model';

export class SuppressionPassageRondeEvent extends UserEvent {
  public static NAME = 'SUPPRESSION_PASSAGE_RONDE';

  constructor(
    public idVacation: string,
    public passage: dayjs.Dayjs,
    instant?: dayjs.Dayjs
  ) {
    super(SuppressionPassageRondeEvent.NAME, instant);
  }

  public static hydrate(obj: SuppressionPassageRondeEvent): SuppressionPassageRondeEvent {
    return new SuppressionPassageRondeEvent(obj.idVacation, dayjs(obj.passage), dayjs(obj.instant));
  }
}
